import React from 'react';

interface PlayerSilhouetteIconProps {
  className?: string;
}

/** Figma empty-state player silhouette (140×115). Color via `className`. */
export const PlayerSilhouetteIcon: React.FC<PlayerSilhouetteIconProps> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="140"
    height="115"
    viewBox="0 0 140 115"
    fill="none"
    className={className}
    aria-hidden
  >
    <path
      d="M116.143 97.8367C105.875 89.7427 93.171 94.5223 85.6307 84.7537C84.0618 82.7186 83.1837 79.4624 83.6052 76.9505C84.0852 74.0431 86.1576 72.3802 87.6212 70.0311C89.998 66.2283 90.8176 61.6812 91.8479 57.7505C91.883 58.4134 92.7026 59.8787 93.6276 59.681C95.9459 59.2042 98.2875 46.1212 97.0581 45.1211C95.4541 44.7606 94.3184 45.8189 93.0539 46.5166C93.932 44.1443 94.0608 40.8997 94.1662 38.411C94.3067 34.8757 94.3535 31.1776 93.2998 27.7586C92.527 25.235 91.2625 23.3743 89.7755 21.3508C86.3684 16.734 81.4625 13.9895 75.8776 12.9894C73.5125 12.5707 70.8781 12.1172 68.4779 12.4079C65.8552 12.7219 63.0218 14.1407 61.7104 16.1758C60.1064 15.1641 57.5071 15.5129 55.4816 16.2805C42.6843 21.1183 42.5789 36.8294 45.1899 46.7376C40.1318 44.2954 42.0052 54.4478 43.1877 56.5643C44.0659 58.1343 46.5129 61.7045 46.829 58.2971C48.3043 60.2973 48.5268 62.9023 49.6742 65.0421C50.7396 67.0539 52.2383 68.9263 53.3623 70.9381C55.9031 75.4619 57.9403 80.0904 54.3575 84.7537C46.8173 94.5223 34.1254 89.7427 23.8454 97.8367C18.3073 102.198 20.3797 117.816 20.3797 117.816H119.62C119.62 117.816 121.693 102.209 116.155 97.8367H116.143Z"
      fill="currentColor"
    />
  </svg>
);
